// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueFire from 'vuefire'
import firebase from './firebase'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
// import * as VueGoogleMaps from 'vue2-google-maps'
import VCharts from 'v-charts'

Vue.config.productionTip = false
Vue.use(VueFire)
Vue.use(VCharts)
Vue.use(firebase)
Vue.use(Vuetify)
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyAKynWbzgZJvxF06n7qeWrvNPEmlKYfqO0',
//     libraries: 'places,drawing,visualization'
//   }
// })
let app
/* eslint-disable no-new */
firebase.auth().onAuthStateChanged(function (user) {
  if (!app) {
    app = new Vue({
      el: '#app',
      template: '<App/>',
      components: { App },
      router
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js